import { makeAutoObservable } from 'mobx';
import moment from 'moment';

class CommentViewModel {
  uiState;

  data;

  editingComment;

  constructor(data, uiState) {
    makeAutoObservable(this);

    this.data = data;
    this.uiState = uiState;
    this.editingComment = this.data.content;
  }

  editCommentClicked() {
    this.uiState.editCommentClicked(this);
  }

  deleteCommentClicked() {
    this.uiState.deleteCommentClicked(this);
  }

  changeEditingComment(comment) {
    this.editingComment = comment;
  }

  submitComment() {
    if (this.uiState.commenting) return;

    this.data.merge({content: this.editingComment});

    if (this.data.id) {
      this.uiState.confirmCommentEdit(this);
    } else {
      this.uiState.submitComment(this);
    }
  }

  get editCommentPlaceholder() {
    if (this.data.id) {
      return 'hr_dashboard.feed.announcements.Edit a comment...';
    } else {
      return 'hr_dashboard.feed.announcements.Add a comment...';
    }
  }

  get editCommentSubmitCaption() {
    if (this.data.id) {
      return 'Save';
    } else {
      return 'hr_dashboard.feed.announcements.Add Comment';
    }
  }

  changeComment(comment) {
    this.editingComment = comment;
  }

  get comment() {
    return this.editingComment;
  }

  get createdTimeAgo() {
    return moment(this.data.createdAt).fromNow();
  }

  get updatedTimeAgo() {
    return moment(this.data.updatedAt).fromNow();
  }

  get hasBeenUpdated() {
    return !moment(this.data.updatedAt).isSame(this.data.createdAt);
  }
}

export default CommentViewModel;
